module.exports = __webpack_public_path__ + "img/10.61c1a680.png";